module.exports = __webpack_public_path__ + "static/media/soccer.d9fef6b5.png";